import { Request } from 'commons/utils/request'

import { ClientPortalInvite } from './types'

export const api = {
  sendClientPortalInvite: (invite: ClientPortalInvite) =>
    Request.post<number, ClientPortalInvite>(Request.urls.bank.clientUser, invite)
}
